
<template>
  <div class="webview">
    <iframe
      :src="href"
      style="width: 100%; height: 100vh; border: none"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      href: "",
    };
  },
  created() {
    this.href = this.$route.query.href;
  },
  activated() {
    this.href = this.$route.query.href;
  },
};
</script>